// Auswahlwerte für Reiseerstellung/-bearbeitung.
// WICHTIG: `value` = interner Backend-Key (muss 1:1 dem Travel-Matching-Vertrag
// entsprechen). `label` ist nur die deutsche Anzeige.

export const TRIP_TYPES = [
  { value: "roadtrip", label: "Roadtrip" },
  { value: "camping", label: "Camping" },
  { value: "wohnmobil", label: "Wohnmobil" },
  { value: "strandurlaub", label: "Strandurlaub" },
  { value: "staedtereise", label: "Städtereise" },
  { value: "backpacking", label: "Backpacking" },
  { value: "wanderreise", label: "Wanderreise" },
  { value: "abenteuerreise", label: "Abenteuerreise" },
  { value: "festivalreise", label: "Festivalreise" },
  { value: "wellnessreise", label: "Wellnessreise" },
  { value: "kreuzfahrt", label: "Kreuzfahrt" },
  { value: "rundreise", label: "Rundreise" },
  { value: "motorradtour", label: "Motorradtour" },
  { value: "skiurlaub", label: "Skiurlaub" },
  { value: "fahrradtour", label: "Fahrradtour" },
  { value: "workation", label: "Workation" },
  { value: "wochenendtrip", label: "Wochenendtrip" },
];

export const TRANSPORT_TYPES = [
  { value: "eigenes_auto", label: "Eigenes Auto" },
  { value: "mietwagen", label: "Mietwagen" },
  { value: "motorrad", label: "Motorrad" },
  { value: "zug", label: "Zug" },
  { value: "flug", label: "Flug" },
  { value: "fahrrad", label: "Fahrrad" },
  { value: "wohnmobil", label: "Wohnmobil" },
];

export const ACCOMMODATION_TYPES = [
  { value: "camping", label: "Camping" },
  { value: "hostel", label: "Hostel" },
  { value: "ferienwohnung", label: "Ferienwohnung" },
  { value: "hotel", label: "Hotel" },
  { value: "wohnmobil", label: "Wohnmobil" },
];

export const PREFERRED_GENDERS = [
  { value: "egal", label: "Egal" },
  { value: "weiblich", label: "Weiblich" },
  { value: "maennlich", label: "Männlich" },
  { value: "divers", label: "Divers" },
];

export const COST_SHARING = [
  { value: "jeder_selbst", label: "Jeder zahlt selbst" },
  { value: "geteilt", label: "Geteilt" },
  { value: "nicht_festgelegt", label: "Nicht festgelegt" },
];

export const VISIBILITY = [
  { value: "public", label: "Öffentlich" },
  { value: "matches_only", label: "Nur Matches" },
  { value: "paused", label: "Pausiert" },
  { value: "closed", label: "Geschlossen" },
];

// Sprachen werden als Anzeige-Strings gespeichert (preferred_languages[]).
export const LANGUAGES = [
  { value: "Deutsch", label: "Deutsch" },
  { value: "Englisch", label: "Englisch" },
  { value: "Spanisch", label: "Spanisch" },
  { value: "Französisch", label: "Französisch" },
  { value: "Italienisch", label: "Italienisch" },
  { value: "Portugiesisch", label: "Portugiesisch" },
  { value: "Niederländisch", label: "Niederländisch" },
  { value: "Polnisch", label: "Polnisch" },
];

// Aktivitäten = exakt die ersten 16 INTERESTS der Mobile-App (INTERESTS.slice(0,16)).
// Wert und sichtbares Label sind identisch, Groß-/Kleinschreibung 1:1.
export const ACTIVITIES = [
  { value: "Strand", label: "Strand" },
  { value: "Wandern", label: "Wandern" },
  { value: "Natur", label: "Natur" },
  { value: "Berge", label: "Berge" },
  { value: "Fotografie", label: "Fotografie" },
  { value: "Geschichte", label: "Geschichte" },
  { value: "Kultur", label: "Kultur" },
  { value: "Museen", label: "Museen" },
  { value: "Essen", label: "Essen" },
  { value: "Nachtleben", label: "Nachtleben" },
  { value: "Festivals", label: "Festivals" },
  { value: "Wellness", label: "Wellness" },
  { value: "Sport", label: "Sport" },
  { value: "Camping", label: "Camping" },
  { value: "Roadtrips", label: "Roadtrips" },
  { value: "Motorrad", label: "Motorrad" },
];
